import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from 'app/config.const';
import { SharedUser } from 'app/model/user';
import { RESTArray } from '../angular-rest';

@Injectable()
export class SharedUsers extends RESTArray<SharedUser> {
	constructor($http: HttpClient) {
		super(
			$http,
			`${Config.baseURL}/utenti`,
			(h, u, r) => <SharedUser>r,
			({ codice_fiscale }) => ({ id: codice_fiscale })
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/model/shared_user.ts